export class ServiciosEspeciales {

    public id: number;
    public codigoConsorcio: string;
    public codigoSucursal: string;
    public codigoServicio: string;
    public fecha: any;
    public codigoDocumento: string;
    public tipoDocumento: string;
    public detalleDocumento: string;
    public montoServicio: number;
    public codigoMoneda: string;
    public estado: string;
    public cantidad: number;
    public total: number;
    public nombreServicio:string;
    
}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/model/servicios-especiales.ts